import { Link } from "react-router-dom";
import { navLinks, site } from "../../mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl">
                <i className="ri-heart-3-fill" />
              </span>
              <div>
                <p className="font-display text-xl text-primary-700">{site.name}</p>
                <p className="text-xs text-foreground-600">{site.tagline}</p>
              </div>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-700">
              {site.description} 从第一集到最终话，按顺序帮你把守护甜心的剧情脉络理得清清楚楚。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href={`mailto:${site.email}`}
                className="inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-sm text-foreground-800 hover:text-primary-600"
              >
                <i className="ri-mail-line" />
                {site.email}
              </a>
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-sm text-foreground-800">
                <i className="ri-question-answer-line" />
                欢迎投稿交流剧情
              </span>
            </div>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="text-sm font-medium text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-600 hover:text-primary-600">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="内容栏目">
            <h4 className="text-sm font-medium text-foreground-950">内容栏目</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/episodes" className="text-sm text-foreground-600 hover:text-primary-600">
                  分集剧情速览
                </Link>
              </li>
              <li>
                <Link to="/analysis" className="text-sm text-foreground-600 hover:text-primary-600">
                  角色与设定解析
                </Link>
              </li>
              <li>
                <Link to="/ending" className="text-sm text-foreground-600 hover:text-primary-600">
                  结局剧情详解
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600">
                  关于与联系
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 {site.name} · 仅用于剧情讨论与整理，非官方站点
          </p>
          <p className="text-xs text-foreground-500">守护甜心，陪你一起长大。</p>
        </div>
      </div>
    </footer>
  );
}